var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_and_text",
    clipPath: "url(#clip0_3208_5948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3208_5948",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60 0H0V60H60V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3208_5948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.0625 26.25C31.6513 26.25 33.75 24.1513 33.75 21.5625C33.75 18.9737 31.6513 16.875 29.0625 16.875C26.4737 16.875 24.375 18.9737 24.375 21.5625C24.375 24.1513 26.4737 26.25 29.0625 26.25Z",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.75 59.0625V31.875C35.8734 31.0266 37.8023 29.9836 39.2813 29.1C41.093 28.0148 42.1875 26.0508 42.1875 23.9367V15.4688C42.1875 14.175 41.1375 13.125 39.8438 13.125C38.55 13.125 37.5 14.175 37.5 15.4688V21.9984C37.5 23.5758 36.4852 24.9891 34.9734 25.4461C33.5789 25.868 31.6102 26.2523 29.0625 26.2523C24.9211 26.2523 20.625 28.1273 20.625 33.7523V37.0617C20.625 39.1453 21.4523 41.1422 22.9266 42.6164L24.375 44.0648V59.0648",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.0625 59.0625V45",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.4375 26.25C11.0263 26.25 13.125 24.1513 13.125 21.5625C13.125 18.9737 11.0263 16.875 8.4375 16.875C5.84867 16.875 3.75 18.9737 3.75 21.5625C3.75 24.1513 5.84867 26.25 8.4375 26.25Z",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.9375 59.0625V44.0625L2.77734 42.6141C1.59844 41.1398 0.9375 39.143 0.9375 37.0594V33.75C0.9375 28.125 4.37344 26.25 7.6875 26.25H9.1875C12.5016 26.25 15.9375 28.125 15.9375 33.75V37.0594C15.9375 39.143 15.2742 41.1398 14.0977 42.6141L12.9375 44.0625V59.0625",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.4375 59.0625V45",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M51.5625 26.25C54.1513 26.25 56.25 24.1513 56.25 21.5625C56.25 18.9737 54.1513 16.875 51.5625 16.875C48.9737 16.875 46.875 18.9737 46.875 21.5625C46.875 24.1513 48.9737 26.25 51.5625 26.25Z",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M47.0625 59.0625V44.0625L45.9023 42.6141C44.7234 41.1398 44.0625 39.143 44.0625 37.0594V33.75C44.0625 28.125 47.4984 26.25 50.8125 26.25H52.3125C55.6266 26.25 59.0625 28.125 59.0625 33.75V37.0594C59.0625 39.143 58.3992 41.1398 57.2227 42.6141L56.0625 44.0625V59.0625",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M51.5625 59.0625V45",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15 8.4375V3.75C15 2.19609 16.2586 0.9375 17.8125 0.9375H31.875C33.4289 0.9375 34.6875 2.19609 34.6875 3.75V8.4375C34.6875 9.99141 33.4289 11.25 31.875 11.25H20.625L21.5625 16.875L17.1352 13.0805C15.7805 11.918 15 10.2234 15 8.4375Z",
    stroke: "#24DEAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3208_5948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService6);
export default __webpack_public_path__ + "static/media/service6.fe61f0abdd24e9a61fe9e6e354e8a8d5.svg";
export { ForwardRef as ReactComponent };